import sanitizeHTML from '../../../utils/sanitiseHTML';
import Reviews from '../../Reviews';

const Award = ({ data }) => {
  const bgClass = data?.showReview === "yes" ? "has-bg" : "no-bg";
  return (
    <div className={`${bgClass} section__award`}>
      <h4>{data?.title}</h4>
      <p
        className="subtitle_1"
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(data?.description) }}
      />
      <div className="section__award__desktop">
        <div className="section__award__desktop__left">
          <img
            src={data?.leftAwardImage?.sourceUrl}
            alt="award-image-left"
            width="259"
            height="136"
          />
          <p className="subtitle_1">{data?.leftAwardTitle}</p>
        </div>
        <div className="section__award__desktop__right">
          <img
            src={data?.rightAwardImage?.sourceUrl}
            alt="award-image-right"
            width="259"
            height="98"
          />
          <p className="subtitle_1">{data?.rightAwardTitle}</p>
        </div>
      </div>
      <div className="section__award__mobile">
        <div className="section__award__mobile__left">
          <img
            src={data?.rightAwardImage?.sourceUrl}
            alt="award-image-right"
            width="218"
            height="81"
          />
          <p className="subtitle_1">{data?.rightAwardTitle}</p>
        </div>
        <div className="section__award__mobile__right">
          <img
            src={data?.leftAwardImage?.sourceUrl}
            alt="award-image-left"
            width="218"
            height="114"
          />
          <p className="subtitle_1">{data?.leftAwardTitle}</p>
        </div>
      </div>
      {
        data?.showReview === "yes" &&
        <Reviews />
      }
    </div>
  );
};

export default Award;
